import React from 'react';
import styled from 'styled-components';
import {
  Breakpoints as VwBreakpoints,
  ThemeDefinition,
} from '@volkswagen-onehub/components-core';
import {Breakpoints} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {TariffsFeatureAppTheme} from '@volkswagen-onehub/whitelabel-e-mobility-tariffs-feature-app';
import {createTariffsFeatureAppThemeV26} from './tariffs-theme-v26';
import {
  isV26,
  ThemeWithVariant,
} from '@volkswagen-onehub/vw-e-mobility-components';

export const TariffsFeatureAppWrapper = (props: {
  children?: React.ReactNode;
}): JSX.Element => <BreakpointsWrapper>{props.children}</BreakpointsWrapper>;

export function createTariffsFeatureAppVariantTheme(theme: ThemeWithVariant) {
  return isV26(theme)
    ? createTariffsFeatureAppThemeV26(theme)
    : createTariffsFeatureAppTheme(theme);
}

export function createTariffsFeatureAppTheme(
  theme: ThemeDefinition
): TariffsFeatureAppTheme {
  return {
    colors: {
      tile: {
        border: theme.colors.border.default,
        headline: {
          background: '#002B79',
        },
        information: {
          content: {
            secondary: theme.colors.content.secondary,
          },
        },
      },
    },
    spacing: {
      appLayout: {
        blockEnd: theme.size.static600,
        blockGap: theme.size.grid001,
      },
      tariffsLayout: {
        marginTop: theme.size.dynamic0200,
        marginBottom: theme.size.dynamic0200,
      },
      tariffsHeader: {
        paddingLeftRight: 'var(--header-padding-left-right)',
      },
      tariffsContentLayout: {
        inlineStart: 'var(--tariffs-content-inline-start)',
        inlineEnd: 'var(--tariffs-content-inline-end)',
        marginTop: {
          mobile: theme.size.static350,
          desktop: theme.size.static450,
        },
      },
      tile: {
        headline: {
          paddingTop: theme.size.static250,
          paddingRight: theme.size.static400,
        },
        information: {
          padding: theme.size.static400,
          gap: theme.size.static350,
          header: {
            gap: theme.size.static150,
            paddingBottom: theme.size.static350,
          },
        },
        buttons: {
          padding: theme.size.static400,
          gap: theme.size.static300,
        },
        borderRadius: '8px',
      },
    },
  };
}

const BreakpointsWrapper = styled.div`
  --header-layout-inline-start: ${(props) => props.theme.size.grid002};
  --header-layout-inline-end: ${(props) => props.theme.size.grid002};
  --header-padding-left-right: ${(props) => props.theme.size.grid003};

  @media (min-width: ${Breakpoints.twoColumnLayout}px) {
    --header-layout-inline-start: ${(props) => props.theme.size.grid001};
    --header-layout-inline-end: ${(props) => props.theme.size.grid001};
  }

  @media (min-width: ${VwBreakpoints.b1280}px) {
    --header-layout-inline-start: ${(props) => props.theme.size.grid007};
    --header-layout-inline-end: ${(props) => props.theme.size.grid007};
    --header-padding-left-right: ${(props) => props.theme.size.grid001};
  }

  @media (min-width: ${VwBreakpoints.b1920}px) {
    --header-layout-inline-start: ${(props) => props.theme.size.grid006};
    --header-layout-inline-end: ${(props) => props.theme.size.grid006};
  }

  --tariffs-content-inline-start: ${(props) => props.theme.size.grid002};
  --tariffs-content-inline-end: ${(props) => props.theme.size.grid002};

  @media (max-width: ${VwBreakpoints.b560}px) {
    --tariffs-content-inline-start: '0';
    --tariffs-content-inline-end: '0';
  }
`;
